module.exports = {"610730001":"袁家庄街道","610730101":"陈家坝镇","610730102":"大河坝镇","610730103":"西岔河镇","610730104":"岳坝镇","610730105":"长角坝镇","610730106":"石墩河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610730.json
// module id = 2648
// module chunks = 0